<h3 class="my-5" translate>billing_tab_billing_data</h3>

<form *ngIf="billingForm" [formGroup]="billingForm" class="mb-5">
  <div formGroupName="billing">
    <!--                <h3 class="my-5" translate>billing_tab_billing_data</h3>-->
    <div class="page__form-wrap">
      <div *ngIf="!userIsPrivate" class="form-group row">
        <label for="companyName" class="col-sm-4" translate>account_company</label>
        <div class="col-sm-8">
          <input
            type="text"
            class="form-control"
            id="companyName"
            formControlName="companyName"
            wsbAppControlValidator
            [fc]="billingForm.get('billing.companyName')"
          />
          <wsb-validation-error-msg [fc]="billingForm.get('billing.companyName')"></wsb-validation-error-msg>
        </div>
      </div>
      <div *ngIf="!userIsPrivate" class="form-group row">
        <label for="vatCode" class="col-sm-4" translate>account_piva</label>
        <div class="col-sm-8">
          <input
            [readonly]="user.account.isCustomer"
            type="text"
            class="form-control"
            id="vatCode"
            formControlName="vatCode"
            wsbAppControlValidator
            [fc]="billingForm.get('billing.vatCode')"
          />
          <wsb-validation-error-msg [fc]="billingForm.get('billing.vatCode')"></wsb-validation-error-msg>
        </div>
      </div>
      <div class="form-group row" *ngIf="user.nation === 'ita'">
        <label for="taxCode" class="col-sm-4" translate>account_cf</label>
        <div class="col-sm-8">
          <input
            [readonly]="user.account.isCustomer"
            type="text"
            class="form-control"
            id="taxCode"
            formControlName="taxCode"
            oninput="this.value = this.value.toLowerCase()"
            wsbAppControlValidator
            [fc]="billingForm.get('billing.taxCode')"
          />
          <wsb-validation-error-msg [fc]="billingForm.get('billing.taxCode')"></wsb-validation-error-msg>
        </div>
      </div>
      <div class="form-group row">
        <label for="address" class="col-sm-4" translate>account_address</label>
        <div class="col-sm-8">
          <input
            type="text"
            class="form-control"
            id="address"
            formControlName="address"
            wsbAppControlValidator
            [fc]="billingForm.get('billing.address')"
          />
          <wsb-validation-error-msg [fc]="billingForm.get('billing.address')"></wsb-validation-error-msg>
        </div>
      </div>
      <div class="form-group row">
        <label for="zipCode" class="col-sm-4" translate>account_zip</label>
        <div class="col-sm-8">
          <input
            type="text"
            class="form-control"
            id="zipCode"
            formControlName="zipCode"
            wsbAppControlValidator
            [fc]="billingForm.get('billing.zipCode')"
          />
          <wsb-validation-error-msg [fc]="billingForm.get('billing.zipCode')"></wsb-validation-error-msg>
        </div>
      </div>
      <div class="form-group row">
        <label for="city" class="col-sm-4" translate>account_city</label>
        <div class="col-sm-8">
          <input
            type="text"
            class="form-control"
            id="city"
            formControlName="city"
            wsbAppControlValidator
            [fc]="billingForm.get('billing.city')"
          />
          <wsb-validation-error-msg [fc]="billingForm.get('billing.city')"></wsb-validation-error-msg>
        </div>
      </div>
      <div class="form-group row" *ngIf="user.nation === 'ita'">
        <label for="province" class="col-sm-4" translate>account_province</label>
        <div class="col-sm-8">
          <input
            type="text"
            class="form-control"
            id="province"
            formControlName="province"
            wsbAppControlValidator
            [fc]="billingForm.get('billing.province')"
          />
          <wsb-validation-error-msg [fc]="billingForm.get('billing.province')"></wsb-validation-error-msg>
        </div>
      </div>
      <div class="form-group row">
        <label for="invoicingEmail" class="col-sm-4" translate>account_invoicing_email</label>
        <div class="col-sm-8">
          <input
            type="text"
            class="form-control"
            id="invoicingEmail"
            formControlName="invoicingEmail"
            wsbAppControlValidator
            [fc]="billingForm.get('billing.invoicingEmail')"
          />
          <wsb-validation-error-msg [fc]="billingForm.get('billing.invoicingEmail')"></wsb-validation-error-msg>
          <small class="form-text text-muted" translate>settings_account_invoicing_email_help</small>
        </div>
      </div>
      <div class="form-group row" *ngIf="user.nation === 'ita'">
        <label for="paCode" class="col-sm-4" translate>settings_account_codice_pa</label>
        <div class="col-sm-8">
          <input
            type="text"
            class="form-control"
            id="paCode"
            formControlName="paCode"
            wsbAppControlValidator
            [fc]="billingForm.get('billing.paCode')"
          />
          <wsb-validation-error-msg [fc]="billingForm.get('billing.paCode')"></wsb-validation-error-msg>
          <small class="form-text text-muted" translate>settings_account_codice_pa_help</small>
        </div>
      </div>
    </div>
  </div>
</form>
